import { FC } from 'react'
import { LinearProgress, Paper, Stack, Typography } from '@mui/material'
import { DashboardKpiBox, DashboardKpiValue } from '../../../types/dashboard.type'
import { dashboardIcons } from '../../../utils/constants'

const KpiValue: FC<DashboardKpiValue> = ({ title, progress, value, color, appendix, icon }) => {
  const Icon = icon ? dashboardIcons[icon] : null

  return (
    <>
      <Typography color="text.secondary">{title}:</Typography>
      <LinearProgress variant="determinate" value={progress} sx={{ height: '10px' }} color={color} />
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography variant="h6" fontWeight="bold" pr={1}>
          {value}
        </Typography>
        <Typography color="text.secondary">{appendix}</Typography>
        {Icon && <Icon sx={{ fontSize: '1.3em', color: color + '.main' }} />}
      </Stack>
    </>
  )
}

interface IProps {
  boxes: DashboardKpiBox[]
}

const Kpi: FC<IProps> = ({ boxes }) => {
  if (!boxes?.length) {
    return null
  }

  return (
    <Stack spacing={2} direction="column" sx={{ width: '400px' }}>
      {boxes.map((b) => (
        <Paper sx={{ px: 3, py: 2, flexGrow: 1 }} key={b.title}>
          <Stack gap={1}>
            <Typography variant="h6" sx={{ textTransform: 'uppercase' }} fontWeight="bold" textAlign="center">
              {b.title}
            </Typography>
            {b.values.map((v) => (
              <KpiValue key={v.title} {...v} />
            ))}
          </Stack>
        </Paper>
      ))}
    </Stack>
  )
}

export default Kpi
